module.exports = __webpack_public_path__ + "static/img/323.4034dd62.jpg";